"use strict";

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.promise");

var toIter = require("./toIter.js");

var go1 = require("./go1.js");

var go2 = require("../.internal/go2.js");

var head = require("./head.js");

module.exports = reduce;

function reduce(f, acc, iter) {
  if (arguments.length == 1) return (..._) => reduce(f, ..._);
  if (arguments.length == 2) return reduce(f, head(iter = toIter(acc)), iter);
  iter = toIter(iter);
  return go1(acc, function recur(acc) {
    let cur;

    while (!(cur = iter.next()).done) {
      acc = go2(acc, cur.value, f);
      if (acc instanceof Promise) return acc.then(recur);
    }

    return acc;
  });
}